import { ConfirmationModal } from "@components/ConfirmationModal";

type Props = {
  isShown: boolean;
  onStay: () => void;
  onLeave: () => void;
};

const ReservationLeavingModal: React.FC<Props> = ({
  isShown,
  onStay,
  onLeave,
}) => {
  return (
    <ConfirmationModal
      isShown={isShown}
      title="予約取り消し"
      message="入力した内容は保存されません。よろしいですか？"
      continueButton={{
        label: "OK",
        onClick: onLeave,
      }}
      abortButton={{
        label: "キャンセル",
        onClick: onStay,
      }}
    />
  );
};

export default ReservationLeavingModal;
